<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Solicitudes Abiertas</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group"></div>
              </div>
              <div class="col-md-12">
                <TiendaSelectComponent :current="current" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <button
                  v-if="current.tienda"
                  @click="imprimir(current)"
                  class="btn btn-secondary btn-sm btn-block"
                >
                  <span>Descargar en PDF</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      incluir_en_blanco: true,
      current: {
        tienda: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {},
  mounted() {
    let self = this;
  },
  methods: {
    imprimir(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/Req_traslados/req_abiertas.jrxml&tienda_id=${current.tienda}`
      );
    },
  },
};
</script>
